import { __extends } from "tslib";
import React from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
var FaveButton = /** @class */ (function (_super) {
    __extends(FaveButton, _super);
    function FaveButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFaveToggle = function () {
            var _a = _this.props, deviation = _a.deviation, onChangeFave = _a.onChangeFave, isFavourite = _a.isFavourite, _b = _a.notificationQueue, notificationQueue = _b === void 0 ? 'default' : _b;
            onChangeFave && onChangeFave(deviation, !isFavourite, notificationQueue);
        };
        return _this;
    }
    FaveButton.prototype.render = function () {
        var _a = this.props, deviation = _a.deviation, isFavourite = _a.isFavourite, faveCount = _a.faveCount, isLoading = _a.isLoading, className = _a.className, ariaLabel = _a["aria-label"];
        return (React.createElement(ErrorBoundary, { debugComponent: "FaveButton" },
            React.createElement(BiButton, { "data-hook": BiDataHook.FAVE_BUTTON, disabled: isLoading, onClick: this.onFaveToggle, className: className, "aria-label": ariaLabel, biData: {
                    evid: isFavourite
                        ? BiEventType.THUMB_CLICK_UNFAVE
                        : BiEventType.THUMB_FAVE,
                    typeid: getDeviationResourceType(deviation),
                    creatorid: deviation.author
                        ? deviation.author.useridUuid
                        : undefined,
                    itemid: deviation.deviationId,
                } }, this.props.children({ isFavourite: isFavourite, faveCount: faveCount }))));
    };
    return FaveButton;
}(React.Component));
export default FaveButton;
//# sourceMappingURL=FaveButton.js.map